export function getMjesta(mjesta) {
    return { type: 'GET_MJESTA', mjesta };
}
